import {
  ReportSummaryOrderItemsTableOptions,
  ReportSummaryTableOptions,
} from '../types';

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DATA_HC_NAME_REPORT_SUMMARY_TABLE_CELL =
  'report-summary-table-cell';
export const REPORT_SUMMARY_TABLE_OPTIONS: ReportSummaryTableOptions[] = [
  'completedDate',
  'order',
  'orderedBy',
  'amountOrdered',
  'productType',
  'label',
  'download',
  'more',
];

export const DATA_HC_NAME_REPORT_SUMMARY_ORDER_ITEMS_TABLE_CELL =
  'report-summary-order-items-table-cell';
export const REPORT_SUMMARY_ORDER_ITEMS_TABLE_OPTIONS: ReportSummaryOrderItemsTableOptions[] =
  ['completedDate', 'fileId', 'address', 'city', 'state', 'zip'];
